import { useContext } from "react";
import GlobalContext from "../../common/Context";
import { Box, Container } from "@mui/material";
import LoadingModal from "../../common/LoadingModal/LoadingModal";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import Header from "../../common/Header";
import { HEADER_HEIGHT } from "../../../constants";

const Docs = () => {
  const { mobileView, docs } = useContext(GlobalContext);

  const bodyStyle = {
    maxHeight: `calc(100vh - ${HEADER_HEIGHT})`,
    overflowY: "auto",
    mt: HEADER_HEIGHT,
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const container = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: mobileView ? "100%" : "60rem",
  };

  return (
    <Box sx={bodyStyle}>
      <Header />
      <Container sx={containerStyle}>
        <Box sx={container}>{docs ? <SwaggerUI spec={docs} /> : <LoadingModal width={6} />}</Box>
      </Container>
    </Box>
  );
};

export default Docs;
